// extracted by mini-css-extract-plugin
export default {"loading-modal":"---------packages-corgi-x-src-components-ActivityModal-ActivityModal-module__loading-modal"};